export function inGame() {
  return window?.FreeFire || window?.webkit?.messageHandlers?.FreeFire
}
